import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
import Blogs from './components/Blogs';
import Contact from './components/Contact';
import Developing from './components/Developing';

import './App.css';

// Placeholder components - replace with your actual components
// const Projects = () => <div className="page-container">Projects Page</div>;
// const Certifications = () => <div className="page-container">Certifications Page</div>;
// const Blogs = () => <div className="page-container">Blogs Page</div>;
// const Contact = () => <div className="page-container">Contact Page</div>;

const App = () => {
  return (
    <Router>
      <div className="app-container">
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/developing" element={<Developing />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;
